import {
  GovtIDProofDetails,
  GovtIDProofActionTypes,
  GOVT_ID_PROOF_FAIL,
  GOVT_ID_PROOF_LOADING,
  GOVT_ID_PROOF_SUCCESS,
  GOVT_ID_PROOF_API_MSG,
  GOVT_ID_PROOF_API_RES,
} from "./ActionTypes";
import { GovtIdProofResponse } from "./Model";

const initialStateGetPosts: GovtIDProofDetails = {
  loading: false,
  govtIdProofResponse: {} as GovtIdProofResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const govtIDProofReducer = (
  state = initialStateGetPosts,
  action: GovtIDProofActionTypes
): GovtIDProofDetails => {
  switch (action.type) {
    case GOVT_ID_PROOF_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GOVT_ID_PROOF_SUCCESS:
      return {
        ...state,
        loading: false,
        govtIdProofResponse: action.payload,
        successMsg: action.successMsg,
      };
    case GOVT_ID_PROOF_FAIL:
      return {
        ...state,
        govtIdProofResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GOVT_ID_PROOF_API_MSG:
      return {
        ...state,
        govtIdProofResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GOVT_ID_PROOF_API_RES:
      return {
        ...state,
        govtIdProofResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
